import { getPostHeaders, getFormDataHeaders } from "./request";
import { JsonValue } from "./patch";
import Result from "../types/result";
import { parseResponse } from "./response";

interface QueryParams {
  [key: string]: string | number | boolean | string[] | number[] | boolean[] | undefined;
}

const createSearchParams = (queryParams: QueryParams): string => {
  const params = new URLSearchParams();

  Object.entries(queryParams).forEach(([key, value]) => {
    if (value === undefined) {
      return;
    }
    if (Array.isArray(value)) {
      value.forEach((item) => params.append(key, String(item)));
    } else {
      params.append(key, String(value));
    }
  });

  // Only return "?" if there are any params to append, otherwise return "
  return params.toString() ? `?${params}` : "";
};

async function post<T>(
  url: string,
  queryParams: QueryParams = {},
  bodyParams: JsonValue | FormData = {},
  requestInit?: Omit<RequestInit, "method" | "headers" | "body">
): Promise<Result<T>> {
  const isFormData = bodyParams instanceof FormData;

  const requestOptions = {
    method: "POST",
    // Use appropriate headers: FormData needs no Content-Type (browser sets multipart boundary)
    headers: isFormData ? await getFormDataHeaders() : await getPostHeaders(),
    body: isFormData ? bodyParams : JSON.stringify(bodyParams),
    ...requestInit
  };

  const urlParams = createSearchParams(queryParams);
  const response = await fetch(url + urlParams, requestOptions);
  const result = await parseResponse<T>(response);
  return result;
}

export default post;
